<template>
  <transition enter-active-class="slideInDown" leave-active-class="slideInUp" appear>
    <div
      class="plc-notification"
      :class="cssClassModifier('plc-notification', notification.type)"
      role="alert"
    >
      <div class="plc-notification__body">
        <gl-svg-icon
          :name="notification.type === 'success' ? 'check' : 'alert'"
          class="plc-notification__icon"
        />
        <p class="plc-notification__text">{{ message }}</p>
      </div>
      <button v-if="false" class="plc-notification__btnClose" @click="handleClickClose">
        <gl-svg-icon name="close" />
      </button>
    </div>
  </transition>
</template>

<script>
import GlSvgIcon from '@gl/GlSvgIcon'
import { cssClassModifier } from '@/mixins'

export default {
  name: 'GlNotification',
  components: {
    GlSvgIcon,
  },
  mixins: [cssClassModifier],
  props: {
    notification: {
      type: Object,
      required: true,
    },
  },
  emits: ['close'],
  computed: {
    message() {
      const messages = {
        success: 'Congratulations! The changes have been saved.',
        wait: 'I am working...',
        error: `<b>Oops!</b> Internal error. Please let us know`,
      }
      return this.notification.message || messages[this.notification.type]
    },
  },
  methods: {
    handleClickClose() {
      this.$emit('close')
    },
  },
}
</script>

<style lang="scss" scoped>
.slideInDown {
  animation: slideInDown 0.3s;
}

.slideInUp {
  animation: slideInDown 0.3s reverse;
}

@keyframes slideInDown {
  from {
    transform: translate3d(0, -100%, 0);
  }

  to {
    transform: translateZ(0);
  }
}

.plc-notification {
  $this: &;
  $notification-list: (
    ('success', rgba(39, 174, 96, 0.7), #fff, #fff),
    ('error', rgba(235, 87, 87, 0.7), #fff, #fff),
    ('wait', rgba(242, 201, 76, 0.87), #000, #f00)
  );

  align-items: center;
  display: flex;
  padding: 13px 16px;

  &__body {
    align-items: center;
    display: flex;
    flex-grow: 1;

    @media (min-width: $breakpoint-md) {
      justify-content: center;
    }
  }

  &__icon {
    flex-shrink: 0;
    margin-right: 8px;
  }

  &__text {
    font-size: 16px;
    line-height: 24px;
  }

  &__btnClose {
    cursor: pointer;
    display: flex;
    margin-left: 8px;
    opacity: 0.5;
    outline: none;
    padding: 0;

    &:hover {
      opacity: 1;
    }
  }

  @each $name, $background, $color, $color-close in $notification-list {
    &--#{$name} {
      background-color: $background;

      #{$this}__icon,
      #{$this}__text {
        color: $color;
      }

      #{$this}__btnClose {
        color: $color-close;
      }
    }
  }
}
</style>
